import { Form, ListItem, Text } from '@domain-group/suit-theme'

import useInvoice from '@hooks/useInvoice'

type InvoicePayloadProps = {
  invoicePayload: ReturnType<typeof useInvoice>,
}

const LinkedCampaign = (props: InvoicePayloadProps) => {
  const { invoicePayload } = props
  const { campaign, callbacks } = invoicePayload

  const { launchInvoiceCampaignModal } = callbacks

  const { title } = campaign

  return (
    <ListItem
      boxProps={{
        fontSize: 'small', borderBottom: '1px solid', padding: 'large',
      }}
      onClick={() => launchInvoiceCampaignModal()}
      showAngleIcon
    >
      <Form.Field
        label="Campaign"
        labelProps={{ style: { alignItems: 'center', padding: 'large' } }}
      >
        <Text fontSize="small">
          {title}
        </Text>
      </Form.Field>
    </ListItem>
  )
}
export default LinkedCampaign
